import React, { Fragment, useEffect } from "react";
import TextField from "@mui/material/TextField";
import Stack from "@mui/material/Stack";
import Autocomplete from "@mui/material/Autocomplete";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { faTrash } from "@fortawesome/free-solid-svg-icons";
import { Button } from "@mui/material";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { v4 as uuidv4 } from "uuid";

const Predio_Descuento_Guia = () => {
  const [noGuia, setNoGuia] = React.useState("");
  const [nuevaExistencia, setNuevaExistencia] = React.useState(0);

  const [descuento, setDescuento] = React.useState(0);

  const [open, setOpen] = React.useState(false);

  const [isDisabled, setIsDisabled] = React.useState(true);

  const [dataTable, setDataTable] = React.useState([]);

  const [maguey, setMaguey] = React.useState({
    id: null,
    num_guia: null,
    edad: null,
    existencia: null,
    especie: null,
  });

  const [nuevoRegistro, setNuevoRegistro] = React.useState(null);

  const [dataMagueySelect, setDataMagueySelect] = React.useState([]);

  const [predio, setPredio] = React.useState({
    id: null,
    num_guia: null,
    num_predio: null,
    nombre_predio: null,
    num_cliente: null,
    nombre_cliente: null,
  });

  const style = {
    "& legend": { display: "none" },
    "& fieldset": { top: 0 },
    background: "#ddd",
    cursor: "not-allowed",
    pointerEvents: "none",
  };

  const dataNoGuias = [
    {
      id: 1,
      num_guia: 8483,
      num_predio: 9886,
      nombre_predio: "Predio_9886",
      num_cliente: 58,
      nombre_cliente: "Eloy Plinio Madrid Sanmiguel",
    },
    {
      id: 2,
      num_guia: 8484,
      num_predio: 9887,
      nombre_predio: "Predio_9887",
      num_cliente: 22,
      nombre_cliente: "Gilberto de Otero",
    },
    {
      id: 3,
      num_guia: 32,
      num_predio: 9888,
      nombre_predio: "Predio_9888",
      num_cliente: 39,
      nombre_cliente: "Manola Velázquez Yuste",
    },
    {
      id: 4,
      num_guia: 33,
      num_predio: 9889,
      nombre_predio: "Predio_9889",
      num_cliente: 6,
      nombre_cliente: "Severiano Segovia Sotelo",
    },
    {
      id: 5,
      num_guia: 34,
      num_predio: 9890,
      nombre_predio: "Predio_9890",
      num_cliente: 28,
      nombre_cliente: "Loida Rius Linares",
    },
    {
      id: 6,
      num_guia: 35,
      num_predio: 9891,
      nombre_predio: "Predio_9891",
      num_cliente: 9,
      nombre_cliente: "Beatriz Serra",
    },
    {
      id: 7,
      num_guia: 36,
      num_predio: 9892,
      nombre_predio: "Predio_9892",
      num_cliente: 61,
      nombre_cliente: "Samu Egea-Cobo",
    },
    {
      id: 8,
      num_guia: 37,
      num_predio: 9893,
      nombre_predio: "Predio_9893",
      num_cliente: 39,
      nombre_cliente: "Marciano Santamaria Marqués",
    },
    {
      id: 9,
      num_guia: 8491,
      num_predio: 9894,
      nombre_predio: "Predio_9894",
      num_cliente: 58,
      nombre_cliente: "Nerea Ballesteros Echevarría",
    },
    {
      id: 10,
      num_guia: 554,
      num_predio: 9895,
      nombre_predio: "Predio_9895",
      num_cliente: 37,
      nombre_cliente: "Encarnación Aparicio",
    },
    {
      id: 11,
      num_guia: 555,
      num_predio: 9896,
      nombre_predio: "Predio_9896",
      num_cliente: 39,
      nombre_cliente: "Sol Martínez Tapia",
    },
    {
      id: 12,
      num_guia: 556,
      num_predio: 9897,
      nombre_predio: "Predio_9897",
      num_cliente: 23,
      nombre_cliente: "Lucila del Cañas",
    },
    {
      id: 13,
      num_guia: 557,
      num_predio: 9898,
      nombre_predio: "Predio_9898",
      num_cliente: 49,
      nombre_cliente: "Rosario Marta Marí Castells",
    },
    {
      id: 14,
      num_guia: 3052,
      num_predio: 9899,
      nombre_predio: "Predio_9899",
      num_cliente: 24,
      nombre_cliente: "Bienvenida Diez Guzmán",
    },
    {
      id: 15,
      num_guia: 3053,
      num_predio: 9900,
      nombre_predio: "Predio_9900",
      num_cliente: 5,
      nombre_cliente: "Macarena Galán Villena",
    },
    {
      id: 16,
      num_guia: 3054,
      num_predio: 9901,
      nombre_predio: "Predio_9901",
      num_cliente: 68,
      nombre_cliente: "Calisto Mateos-Gómez",
    },
    {
      id: 17,
      num_guia: 3055,
      num_predio: 9902,
      nombre_predio: "Predio_9902",
      num_cliente: 59,
      nombre_cliente: "Albano del Roca",
    },
    {
      id: 18,
      num_guia: 3056,
      num_predio: 9903,
      nombre_predio: "Predio_9903",
      num_cliente: 75,
      nombre_cliente: "Florencia Moraleda Carlos",
    },
    {
      id: 19,
      num_guia: 3057,
      num_predio: 9904,
      nombre_predio: "Predio_9904",
      num_cliente: 67,
      nombre_cliente: "Imelda Salvador Ibarra",
    },
    {
      id: 20,
      num_guia: 3058,
      num_predio: 9905,
      nombre_predio: "Predio_9905",
      num_cliente: 21,
      nombre_cliente: "Ezequiel Cánovas Tamarit",
    },
    {
      id: 21,
      num_guia: 3059,
      num_predio: 9906,
      nombre_predio: "Predio_9906",
      num_cliente: 47,
      nombre_cliente: "Paca Teruel Iborra",
    },
    {
      id: 22,
      num_guia: 2435,
      num_predio: 9907,
      nombre_predio: "Predio_9907",
      num_cliente: 1,
      nombre_cliente: "Pía de Asenjo",
    },
    {
      id: 23,
      num_guia: 2436,
      num_predio: 9908,
      nombre_predio: "Predio_9908",
      num_cliente: 36,
      nombre_cliente: "Mariano Rebollo Mora",
    },
    {
      id: 24,
      num_guia: 2437,
      num_predio: 9909,
      nombre_predio: "Predio_9909",
      num_cliente: 25,
      nombre_cliente: "Celia Mariscal Duarte",
    },
    {
      id: 25,
      num_guia: 2438,
      num_predio: 9910,
      nombre_predio: "Predio_9910",
      num_cliente: 6,
      nombre_cliente: "Clementina Cardona",
    },
    {
      id: 26,
      num_guia: 2439,
      num_predio: 9911,
      nombre_predio: "Predio_9911",
      num_cliente: 20,
      nombre_cliente: "Carmelita Colom",
    },
    {
      id: 27,
      num_guia: 12,
      num_predio: 9912,
      nombre_predio: "Predio_9912",
      num_cliente: 5,
      nombre_cliente: "Maristela Vall-Ocaña",
    },
    {
      id: 28,
      num_guia: 13,
      num_predio: 9913,
      nombre_predio: "Predio_9913",
      num_cliente: 53,
      nombre_cliente: "Flavio Cornejo Olivé",
    },
    {
      id: 29,
      num_guia: 14,
      num_predio: 9914,
      nombre_predio: "Predio_9914",
      num_cliente: 7,
      nombre_cliente: "Amor Calatayud Moya",
    },
  ];

  const dataMaguey = [
    {
      id: 1,
      num_guia: 8483,
      edad: 2,
      existencia: 80,
      especie: "Maguey_especie_8483",
    },
    {
      id: 2,
      num_guia: 8484,
      edad: 3,
      existencia: 15,
      especie: "Maguey_especie_8484",
    },
    {
      id: 3,
      num_guia: 32,
      edad: 9,
      existencia: 68,
      especie: "Maguey_especie_32",
    },
    {
      id: 4,
      num_guia: 33,
      edad: 2,
      existencia: 99,
      especie: "Maguey_especie_33",
    },
    {
      id: 5,
      num_guia: 34,
      edad: 9,
      existencia: 19,
      especie: "Maguey_especie_34",
    },
    {
      id: 6,
      num_guia: 35,
      edad: 6,
      existencia: 21,
      especie: "Maguey_especie_35",
    },
    {
      id: 7,
      num_guia: 36,
      edad: 8,
      existencia: 77,
      especie: "Maguey_especie_36",
    },
    {
      id: 8,
      num_guia: 37,
      edad: 5,
      existencia: 10,
      especie: "Maguey_especie_37",
    },
    {
      id: 9,
      num_guia: 8491,
      edad: 3,
      existencia: 12,
      especie: "Maguey_especie_8491",
    },
    {
      id: 10,
      num_guia: 554,
      edad: 6,
      existencia: 16,
      especie: "Maguey_especie_554",
    },
    {
      id: 11,
      num_guia: 555,
      edad: 2,
      existencia: 17,
      especie: "Maguey_especie_555",
    },
    {
      id: 12,
      num_guia: 556,
      edad: 6,
      existencia: 53,
      especie: "Maguey_especie_556",
    },
    {
      id: 13,
      num_guia: 557,
      edad: 9,
      existencia: 19,
      especie: "Maguey_especie_557",
    },
    {
      id: 14,
      num_guia: 3052,
      edad: 10,
      existencia: 46,
      especie: "Maguey_especie_3052",
    },
    {
      id: 15,
      num_guia: 3053,
      edad: 6,
      existencia: 66,
      especie: "Maguey_especie_3053",
    },
    {
      id: 16,
      num_guia: 3054,
      edad: 1,
      existencia: 43,
      especie: "Maguey_especie_3054",
    },
    {
      id: 17,
      num_guia: 3055,
      edad: 5,
      existencia: 59,
      especie: "Maguey_especie_3055",
    },
    {
      id: 18,
      num_guia: 3056,
      edad: 8,
      existencia: 54,
      especie: "Maguey_especie_3056",
    },
    {
      id: 19,
      num_guia: 3057,
      edad: 4,
      existencia: 69,
      especie: "Maguey_especie_3057",
    },
    {
      id: 20,
      num_guia: 3058,
      edad: 6,
      existencia: 2,
      especie: "Maguey_especie_3058",
    },
    {
      id: 21,
      num_guia: 3059,
      edad: 1,
      existencia: 70,
      especie: "Maguey_especie_3059",
    },
    {
      id: 22,
      num_guia: 2435,
      edad: 2,
      existencia: 5,
      especie: "Maguey_especie_2435",
    },
    {
      id: 23,
      num_guia: 2436,
      edad: 9,
      existencia: 87,
      especie: "Maguey_especie_2436",
    },
    {
      id: 24,
      num_guia: 2437,
      edad: 10,
      existencia: 28,
      especie: "Maguey_especie_2437",
    },
    {
      id: 25,
      num_guia: 2438,
      edad: 9,
      existencia: 90,
      especie: "Maguey_especie_2438",
    },
    {
      id: 26,
      num_guia: 2439,
      edad: 1,
      existencia: 59,
      especie: "Maguey_especie_2439",
    },
    {
      id: 27,
      num_guia: 12,
      edad: 2,
      existencia: 48,
      especie: "Maguey_especie_12",
    },
    {
      id: 28,
      num_guia: 13,
      edad: 2,
      existencia: 87,
      especie: "Maguey_especie_13",
    },
    {
      id: 29,
      num_guia: 14,
      edad: 9,
      existencia: 12,
      especie: "Maguey_especie_14",
    },
  ];

  const handlerSeleccion = (value) => {
    setPredio(value);

    const aux = dataMaguey.filter((item) => {
      if (!value) {
        return null;
      }
      return item.num_guia === value.num_guia;
    });

    aux.length > 0 ? setDataMagueySelect(aux) : setDataMagueySelect([]);
  };

  const handlerDescuento = (e) => {
    setDescuento(e);
    maguey && e > 0
      ? setNuevaExistencia(maguey.existencia - e)
      : setNuevaExistencia(maguey.existencia);
  };

  useEffect(() => {
    setDataMagueySelect([]);
    setIsDisabled(true);
    setPredio({
      id: null,
      num_guia: null,
      num_predio: null,
      nombre_predio: null,
      num_cliente: null,
      nombre_cliente: null,
    });
    setMaguey({
      id: null,
      num_guia: null,
      edad: null,
      existencia: null,
      especie: null,
    });
  }, []);


  const agregarElemento = () => {
    const { num_guia, especie, edad, existencia } = maguey;
    const id = uuidv4();

    const elemento = {
      id,
      especie,
      edad,
      existencia,
      descuento,
      nueva_existencia: nuevaExistencia,
    };
    const aux = [...dataTable, elemento];

    setDataTable(aux);
  };

  const eliminarData = (e) => {
    const aux = dataTable.filter((item) => item.id !== e.toString());
    setDataTable(aux);
  };

  React.useEffect(() => {
    if (predio === null || maguey === null) {
      setIsDisabled(true);
    } else if (predio.num_guia === null || maguey.num_guia === null) {
      setIsDisabled(true);
    } else {
      setIsDisabled(false);
    }
  }, [predio, maguey]);

  return (
    <Fragment>
      <br />
      <div className="container">
        <h2 className="text-center">Actualización de Predios</h2>
        <div className="bg-light p-5 rounded ms-5">
          <div className="row">
            <div className="col-6">
              <h3 className="text-center">Datos del predio</h3>
              <div className="pt-2">
                <div className="row g-3">
                  <div className="col-sm-6">
                    <label className="form-label">No. Predio: "A":</label>
                    <TextField
                      disabled
                      fullWidth
                      sx={style}
                      size="small"
                      value={
                        predio && predio.num_predio ? predio.num_predio : ""
                      }
                    />
                  </div>

                  <div className="col-sm-6">
                    <label className="form-label">No. Guia: "A":</label>
                    <Autocomplete
                      freeSolo
                      open={open}
                      onOpen={() => {
                        if (noGuia) {
                          setOpen(true);
                        }
                      }}
                      onClose={() => setOpen(false)}
                      inputValue={noGuia}
                      onInputChange={(e, value) => {
                        setNoGuia(value);

                        if (!value) {
                          setOpen(false);
                        }
                      }}
                      onChange={(event, value) => {
                        handlerSeleccion(value);
                      }}
                      options={dataNoGuias}
                      getOptionLabel={(opcion) => opcion.num_guia + ""}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="outlined"
                          sx={{
                            "& legend": { display: "none" },
                            "& fieldset": { top: 0 },
                          }}
                          size="small"
                          style={{ background: "white" }}
                          fullWidth
                        />
                      )}
                    />
                  </div>


                  <div className="col-12">
                    <label className="form-label">Nombre del Predio:</label>
                    <TextField
                      disabled
                      fullWidth
                      sx={style}
                      size="small"
                      value={
                        predio && predio.nombre_predio
                          ? predio.nombre_predio
                          : ""
                      }
                    />
                  </div>

                  <div className="col-12">
                    <label className="form-label">No. Cliente:</label>
                    <TextField
                      disabled
                      fullWidth
                      sx={style}
                      size="small"
                      value={
                        predio && predio.num_cliente ? predio.num_cliente : ""
                      }
                    />
                  </div>

                  <div className="col-12">
                    <label className="form-label">Nombre Cliente:</label>
                    <TextField
                      disabled
                      fullWidth
                      sx={style}
                      size="small"
                      value={
                        predio && predio.nombre_cliente
                          ? predio.nombre_cliente
                          : ""
                      }
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="col-6">
              <h3 className="text-center"> Datos del Maguey</h3>
              <div className="pt-2">
                <div className="row g-3">
                  <div className="col-sm-12">
                    <label className="form-label">Especie:</label>
                    <Autocomplete
                      disablePortal
                      options={dataMagueySelect}
                      onChange={(event, value) => {
                        setMaguey(value);
                      }}
                      getOptionLabel={(opcion) =>
                        predio && opcion !== "" ? opcion.especie : ""
                      }
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          sx={{
                            "& legend": { display: "none" },
                            "& fieldset": { top: 0 },
                          }}
                          size="small"
                          style={{ background: "white" }}
                        />
                      )}
                    />
                  </div>

                  <div className="col-sm-6">
                    <label className="form-label">Existencia</label>
                    <TextField
                      disabled
                      fullWidth
                      sx={style}
                      size="small"
                      value={
                        predio != null &&
                          maguey !== null &&
                          maguey.existencia !== null
                          ? maguey.existencia
                          : ""
                      }
                    />
                  </div>

                  <div className="col-sm-6">
                    <label className="form-label">Descuento</label>
                    <TextField
                      fullWidth
                      sx={{
                        "& legend": { display: "none" },
                        "& fieldset": { top: 0 },
                      }}
                      type="number"
                      inputProps={{
                        inputMode: "numeric",
                        min: 0,
                        max:
                          predio != null &&
                            maguey !== null &&
                            maguey.existencia > 0
                            ? maguey.existencia
                            : 0,
                      }}
                      size="small"
                      defaultValue={0}
                      onChange={(e) => handlerDescuento(e.target.value)}
                    />
                  </div>
                  <div className="col-sm-6">
                    <label className="form-label">Nueva Existencia</label>
                    <TextField
                      disabled
                      fullWidth
                      sx={style}
                      size="small"
                      value={
                        predio !== null &&
                          maguey !== null &&
                          (maguey.existencia !== undefined ||
                            maguey.existencia !== null)
                          ? nuevaExistencia
                          : ""
                      }
                    />
                  </div>

                  <div className="col-sm-12">
                    <label className="form-label">
                      <br />
                    </label>
                    <Button
                      fullWidth
                      disabled={isDisabled}
                      variant="contained"
                      onClick={() => agregarElemento()}
                    >
                      Agregar
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-12 pt-4">
            <Paper sx={{ width: "100%" }}>
              <TableContainer sx={{ maxHeight: 600 }}>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>Especie</TableCell>
                      <TableCell>Edad</TableCell>
                      <TableCell>Existencia</TableCell>
                      <TableCell>Descuento</TableCell>
                      <TableCell>Nueva Existencia</TableCell>
                      <TableCell>Opciones</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {dataTable.map((item, i) => (
                      <TableRow
                        key={item.id}
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                      >
                        <TableCell>{item.especie}</TableCell>
                        <TableCell>{item.edad}</TableCell>
                        <TableCell>{item.existencia}</TableCell>
                        <TableCell>{item.descuento}</TableCell>
                        <TableCell>{item.nueva_existencia}</TableCell>
                        <TableCell>
                          <button
                            className="badge btn-warning text-dark btn-block"
                            onClick={() => eliminarData(item.id)}
                          >
                            <FontAwesomeIcon icon={faTrash} />
                            <br />
                            borrar
                          </button>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Paper>
            <div className="pt-2 texte-center ">
              <Button
                fullWidth
                variant="contained"
                disabled={dataTable.length > 0 ? false : true}
                onClick={() => alert("Guardado")}
              >
                Guardar
              </Button>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default Predio_Descuento_Guia;
